/* eslint-disable react-hooks/exhaustive-deps */
import { useGlobalStore } from "@/store/GlobalStore";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Form } from "@renderbus/ui";
import {
  CardListContent,
  CpuQingCloudWrapper,
  InputNumberWrapper,
  QingCloudCard,
  QingCloudCardList,
  QingCloudRechargeWrapper,
  QingCloudWrapper,
} from "./atom";
import { useUserPropertyStore } from "@/store2/userProperty/user-property-store";
import {
  OrderPaymentTypeCode,
  PaymentPurposeCode,
  PaymentTypeCode,
  QRCODE_QUERY_MAP,
  rechargeChannelsCode,
} from "project-config/constants";
import { couponTypeTranslate } from "@/components/top-up/help/couponTypeTranslate";
import { useEffect, useState } from "react";
import CheckIcon from "@/assets/icons/topup/check";
import DesktopCouponIcon from "@/assets/icons/topup/desktop-coupon-icon";
import LeftIcon from "@/assets/icons/topup/left-icon";
import RightIcon from "@/assets/icons/topup/right-icon";
import { useAnimationTopUpStore } from "../../store";
import {
  presentAmountCalculate,
  rulesContentList,
} from "@/components/top-up/help/activityUtil";
import { BindActivityInfo } from "@/components/top-up/types";
import { useScrollCard } from "./hooks/useScrollCard";
import { PaymentWay } from "../payment-way";
import { RechargeTips } from "../../help/tips";
import { ExtraWelfareTipType } from "../../types";
import { CommonCornerMark, CommonTitle, CommonUpperPart } from "../../atom";
import ActivityRule from "@/components/top-up/components/activity-rule";
import { ExtraWelfareType } from "../../constants/animation-balance-info";

export function DesktopRecharge({
  activityInfo,
}: {
  activityInfo: BindActivityInfo;
}) {
  const { t } = useTranslation("topup");
  const { userProperty } = useUserPropertyStore();
  const {
    isZh,
    currencySymbol,
    userCumulative,
    isAnimationActiveOverTime,
    userInfo,
    userLevel,
  } = useGlobalStore();

  const [openActivityRuleDrawer, setOpenActivityRuleDrawer] = useState(false);
  const [checkCard, setCheckCard] = useState(activityInfo.activityDetail[0]);
  const [error, setError] = useState("");

  const [searchParams] = useSearchParams();
  const amount = useAnimationTopUpStore((state) => state.amount);
  const paying = useAnimationTopUpStore((state) => state.paying);
  const desktopAmount = useAnimationTopUpStore((state) => state.desktopAmount);
  const addPayRecord = useAnimationTopUpStore((state) => state.addPayRecord);
  const { setter: setAnimationTopUpStore } = useAnimationTopUpStore();
  const { wrapperRef, isLeftHidden, isRightHidden, scrollRight, scrollLeft } =
    useScrollCard();
  const [desktopTip, setDesktopTip] = useState<ExtraWelfareTipType[]>();

  const onCpuCloudAmountChange = (value: any) => {
    const val = value ? Math.floor(parseFloat(value)) : value;
    setAnimationTopUpStore({
      desktopAmount: val,
    });
    if (val >= 1 && val <= 200000) {
      setAnimationTopUpStore({
        amount: val,
      });
      setError("");
    } else {
      setAnimationTopUpStore({
        amount: 0,
      });
      if (typeof val !== "undefined" && val !== null) {
        setError(
          `${t("topup_input_between_tip", {
            min: 1,
            max: 200000,
          })}`
        );
        return;
      }
      setError("");
    }
  };

  const onPasteChange = (event: any) => {
    event.preventDefault();
  };

  const limitKeyDown = (e: any) => {
    if (
      !(
        (e.key >= "0" && e.key <= "9") ||
        e.key === "Backspace" ||
        e.key === "Delete" ||
        e.key === "." ||
        e.key === "ArrowLeft" ||
        e.key === "ArrowRight"
      )
    ) {
      e.preventDefault();
      return false;
    }
    return true;
  };

  const qrcodeLink = () => {
    const paramsStr = `&${QRCODE_QUERY_MAP.orderType}=${
      OrderPaymentTypeCode.Desktop
    }&${QRCODE_QUERY_MAP.amount}=${Number(amount)}&${
      QRCODE_QUERY_MAP.rechargeGoal
    }=${PaymentPurposeCode.OrdinaryRecharge}`;

    return paramsStr;
  };

  const onClickCantScanCode = async () => {
    let params = {};
    params = {
      agent: searchParams.get("agent") || "",
      currency: userInfo?.zone,
      payMethod: PaymentTypeCode.DesktopAlipay,
      amount: Number(amount),
      rechargeGoal: PaymentPurposeCode.OrdinaryRecharge,
      rechargeChannels: rechargeChannelsCode.Web,
    };
    await addPayRecord(params);
  };

  const preventWheel = (e: any) => {
    e.preventDefault();
  };

  useEffect(() => {
    setCheckCard(activityInfo.activityDetail[0]);
    setError("");
    setAnimationTopUpStore({
      amount: activityInfo.activityDetail[0].amount,
      desktopAmount: null,
    });
  }, []);

  useEffect(() => {
    const rechargeTips = new RechargeTips({
      amount: Number(amount),
      userProperty,
      userLevel,
      userCumulative,
      currencySymbol,
      isAnimationActiveOverTime,
      activityInfo,
    });
    void rechargeTips.init();
    setDesktopTip(
      rechargeTips.extraWelfareTip.filter(
        (item) => item.type === ExtraWelfareType.Desktop
      )
    );
  }, [amount, userProperty, currencySymbol, activityInfo]);

  useEffect(() => {
    // 防止滚轮滚动的自增自减
    const inputElement = document.querySelector(".qing-cloud-input input");
    if (inputElement) {
      inputElement.addEventListener("wheel", preventWheel, { passive: false });
    }
    return () => {
      if (inputElement) {
        inputElement.removeEventListener("wheel", preventWheel);
      }
    };
  }, []);

  return (
    <QingCloudRechargeWrapper>
      <ActivityRule
        ruleList={rulesContentList(activityInfo, isZh)}
        openRuleDrawer={openActivityRuleDrawer}
        changeDrawer={(val) => {
          setOpenActivityRuleDrawer(val);
        }}
        activityInfo={activityInfo}
      />
      <CommonUpperPart>
        <QingCloudWrapper>
          <CardListContent>
            {activityInfo.activityDetail.length > 4 && !isLeftHidden && (
              <LeftIcon
                onClick={scrollLeft}
                className="scroll-button left-button"
              />
            )}
            <div className="qing-cloud-card-list-wrapper" ref={wrapperRef}>
              <QingCloudCardList className="cards-wrapper">
                {activityInfo.activityDetail.map((item) => {
                  const price = item.amount || 0;
                  const isCheckedCard = checkCard.amount === price;
                  return (
                    <QingCloudCard
                      isActive={isCheckedCard}
                      onClick={() => {
                        setCheckCard(item);
                        onCpuCloudAmountChange(null);
                        setAnimationTopUpStore((state) => {
                          state.amount = price;
                        });
                      }}
                      key={item.id}
                    >
                      {item.iconWord && item.iconWord !== "" && (
                        <CommonCornerMark>{item.iconWord}</CommonCornerMark>
                      )}
                      <div className="recharge-price">
                        <div>
                          <span className="unit">{currencySymbol}</span>
                          <span className="price">{price}</span>
                        </div>
                        {isCheckedCard && <CheckIcon />}
                      </div>
                      <div className="extra-welfare">
                        <div className="tip-text">
                          {t("activity_qing_cloud_arrive")}
                        </div>
                        <div className="gift-amount">
                          <DesktopCouponIcon />
                          <span>
                            {currencySymbol}
                            {presentAmountCalculate(
                              activityInfo,
                              price,
                              item.presentAmount
                            ) ?? 0}
                            &nbsp;
                            {couponTypeTranslate(item.couponType ?? 0)}
                          </span>
                        </div>
                      </div>
                    </QingCloudCard>
                  );
                })}
              </QingCloudCardList>
            </div>
            {activityInfo.activityDetail.length > 4 && !isRightHidden && (
              <RightIcon
                onClick={scrollRight}
                className="scroll-button right-button"
              />
            )}
          </CardListContent>
        </QingCloudWrapper>
        <CpuQingCloudWrapper>
          <CommonTitle>{t("topup_other_amount")}</CommonTitle>
          <Form layout="vertical">
            <Form.Item validateStatus={error ? "error" : ""} help={error}>
              <InputNumberWrapper
                className="qing-cloud-input"
                size={"large"}
                prefix={currencySymbol}
                style={{ width: 220 }}
                controls={false}
                value={desktopAmount}
                onPaste={onPasteChange}
                onChange={onCpuCloudAmountChange}
                type="number"
                pattern="[0-9]*"
                onKeyDown={limitKeyDown}
                placeholder={t("general_enter_amount")}
              />
            </Form.Item>
          </Form>
        </CpuQingCloudWrapper>
      </CommonUpperPart>
      <PaymentWay
        paying={paying}
        onClickCantScanCode={() => void onClickCantScanCode()}
        qrcodeLink={qrcodeLink()}
        desktopTip={desktopTip}
      />
    </QingCloudRechargeWrapper>
  );
}
